// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-vantage -> weidner-apartment-homes-vantage -> the-palms-at-briarwood
// Generated: 2026-10-27T17:07:34.356Z
// Counts: 0 design, 23 content, 19 slot group, 2 collection binding, 9 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "right-middle",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>In <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-loader.inject_dni_classes": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "facebook-pixel.pixel_ids": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_pixel_id"
  },
  "footer.social_label": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p><span style=\"font-size: 11pt;\">Pit Bull &amp; Pit Bull Mixes&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">American Pit Bull Terrier&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">American Staffordshire Terrier&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Wolf Hybrids&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Doberman Pinscher&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Saint Bernard&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">American Bulldog&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Staffordshire Bull Terrier&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Rottweiler&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">German Shepherd&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Chow Chow&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Great Dane&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Akita&nbsp;</span></p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Enjoy thoughtful features in your apartment, including stainless steel appliances, electric fireplaces, generous storage, and flexible workspaces. Step into community spaces designed for relaxation and connection, with a resort-style pool, year-round spa, and a 24-hour fitness center. At Palms at Briarwood, both in-home comforts and outdoor amenities are yours to enjoy in Midland, TX.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Reach out to our leasing team to find out more about available apartments, schedule a tour, or ask questions about life at Palms at Briarwood. We’re here to make your apartment journey simple.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Palms at Briarwood, our one, two, and three-bedroom apartments for rent in Midland, TX, offer the space and comfort your lifestyle deserves. Open-concept living means room for your favorite furniture and plenty of natural light. Enjoy extra storage options, walk-in closets for easy organization, and versatile spaces perfect for working from home. Stainless steel appliances and an inviting electric fireplace bring warmth and style to every home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Step inside Palms at Briarwood’s photo gallery and imagine your day beginning in a sun-filled kitchen, unwinding by your electric fireplace, or stepping onto a private balcony. From updated appliances to plush community spaces, every photo highlights the inviting feel and modern style that set our apartments and amenities apart in Midland, TX.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the best of Midland living in the Briarwood neighborhood. At Palms at Briarwood, you’re close to everyday stops like Walmart, Midland Park Mall, CVS, and unique dining from Taqueria Jalisco Midland to Texas Roadhouse. With easy routes to Loop 250, Highway 158, and Highway 191, commutes and outdoor escapes are simple. Bush Tennis Center, John P. Butler Park, and C.J. Kelly Park are all just minutes away. Enjoy neighborhood strolls, coffee runs, and a lifestyle where everything feels convenient.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Nestled in Midland’s Briarwood neighborhood, you’re just steps from shops, eateries, and entertainment. Midland Park Mall and Walmart are right around the corner, and the community’s close to Loop 250, Highway 158, and Highway 191. Head to Bush Tennis Center for outdoor fun or relax at nearby parks like John P. Butler Park and C.J. Kelly Park. Wherever your day takes you, everything feels close.&nbsp;</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Searching for apartments for rent in Midland, TX? Palms at Briarwood stands out with a pet-friendly vibe, thoughtful amenities, and flexible living spaces. Picture sunlit rooms and simple commutes that make you feel right at home whether you’re winding down after work, enjoying community events, or exploring nearby Midland Park Mall. Ease into comfort, convenience, and community every day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Pick how you explore Palms at Briarwood - tour in-person with a friendly team member, or discover your options virtually from anywhere. Whether you’re looking for a detailed walk-through or a quick look at our floor plans and amenities, scheduling is easy and fits your pace. Touring restrictions may apply - ask us for details!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>With our virtual tour, you can explore Palms at Briarwood right from your phone or laptop. Picture yourself relaxing by the pool, hosting friends in bright living spaces, or settling into a cozy home office nook. Walk through different floor plans, get a feel for the atmosphere, and see what sets our Midland apartments apart. It’s the closest thing to being here in person - and it’s available wherever you are.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "multihub-lead-form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": "/thank-you"
      }
    }
  },
  "contactform.form.success_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "footer.contact_us_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "amenities-hero.bg_image": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "contact-hero.bg_image": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "floor-plans-hero.bg_image": {
    "sourceIndex": 2,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": 9,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_3": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "footer.bg_image": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "future-residents-club-hero.bg_image": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "gallery-hero.bg_image": {
    "sourceIndex": 9,
    "fieldOverrides": null
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[17].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[17].image_media.alt_text"
      }
    }
  },
  "neighborhood-hero.bg_image": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "pet-policy-hero.bg_image": {
    "sourceIndex": 21,
    "fieldOverrides": null
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "neighborhoodsection.photos": {
    "limit": null,
    "hiddenIds": [
      "ec_36b0a50296445a2fd1b4a2ad",
      "ec_825c8c6857a404372feaced9"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "photogallery.images": {
    "limit": null,
    "hiddenIds": [
      "ec_a2c105cddcc64234f7bd137f",
      "ec_ad5f9118bb3bf6bfb99696dc"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      1,
      10
    ],
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 8
    }
  ]
};

export const styleOverrides = {};
